import React, { Component } from 'react';
import { Section, Header } from '../components/ui';

// Desing
import logo from '../assets/img/logo.svg';
import concept from '../assets/img/parking-concept-new.png';

class Qa extends Component {
    render() {
        const slogan = 'Góð geymsla fyrir bílinn meðan þú ferðast. Njóttu einfaldar og fljótlegrar þjónustu Lagningar';
        return (
            <div>
                <Header title={'Tryggðu þér stæði'} subtitle={slogan} concept={concept} logo={logo} />
                <Section title={'Algengar Spurningar og svör'} centered theme={'primary'}>
                    <b>Hvernig þekki ég starfsmann Lagningar?</b>
                    <p>
                        Starfsmaður bíður eftir þér við inngang Leifsstöðvar brottfaramegin, þar sem farþegum er skutlað í flug.
                        Þegar þú svo lendir, bíður þín starfsmaður Lagningar fyrir framan inngang brottfara.
                    </p>

                    <b>Hvað ef ég er ekki með upplýsingar um heimkomu?</b>
                    <p>
                        Það eru margir sem skella sér á flugferð aðra leið. Um leið og þú veist hvenær þú ætlar að koma aftur
                        hefurðu samband við okkur í síma 778-5999 eða tölvupósti lagning@lagning.is og gefur okkur upp flugnúmer.
                        Við erum á vakt allan sólarhringinn.{' '}
                    </p>

                    <b>Hvað ef það eru seinkanir á brottför eða heimkomu?</b>
                    <p>
                        Ef seinkun á flugi er innan þriggja tíma þá þarftu ekki að tilkynna okkur það. Við erum að fylgjast með
                        flugnúmerinu þínu. Ef seinkun fer framyfir þennan tíma er vissara að láta okkur vita í símtali eða í
                        vefpósti.
                    </p>

                    <b>Hvar er bíllinn minn á meðan ég sóla mig á Tene?</b>
                    <p>
                        Bíllinn þinn verður staðsettur í um 6 km fjarlægð frá flugstöðinni á afgirtu bílastæði í umsjá
                        íþróttafélaganna á Suðurnesjum. Starfsemi er þar allan sólarhringinn og stæðið er vaktað með
                        myndavélakerfi. Með því að versla við okkur styrkir þú því í leiðinni íþróttaiðkun á Suðurnesjum.
                    </p>
                    {/* 
          <b>Er bíllinn inni eða úti?</b>
          <p>
            Þú getur valið um inni eða útistæði. Grunngjald fyrir geymslu á bíl
            er 5000. Dagsgjaldið fyrir útistæði er 450 kr. og gjaldið fyrir
            innistæði er 550 kr. aukalega.{" "}
          </p> */}

                    <b>Get ég pantað stæði fyrir bílinn með litlum eða nær engum fyrirvara?</b>
                    <p>
                        Við tökum á móti öllum viðskiptavinum með glöðu geði og mælum allajafna með því að bóka stæði á vefsíðunni
                        okkar. Ef þú þarft hins vegar að panta stæði hjá okkur samdagurs skaltu endilega bjalla í okkur í síma 778
                        5999. Við getum tekið á móti pöntunum með allt niður í 5-10 mínútna fyrirvara.{' '}
                    </p>

                    <b>Hvað ef áætlanir mínar breytast, hvort sem er við brottför eða við komu?</b>
                    <p>
                        Við erum á vakt allan sólarhringinn og svörum í síma ef það er eitthvað. Þá höldum við mjög nákvæma skrá
                        yfir tímasetningar og breytingar á þeim. Einnig geturðu sent okkur tölvupóst á lagning@lagning.is um
                        breytingar á flugi. Ef flugnúmer breytist skaltu senda okkur upplýsingar um nýjan komutíma og nýtt
                        flugnúmer svo við getum fylgst með komu þinni.{' '}
                    </p>

                    <b>Er bíllinn öruggari hjá ykkur en t.d. á bílastæði Leifsstöðvar?</b>
                    <p>
                        Bílastæðin okkar eru afar örugg og er lámárks áhætta á tjóni. Bílum er lagt skilvirknislega af fólki með
                        reynslu sem hurðar aldrei. Hvorki farangurskerrur né fríhafnargrindur ganga lausar á bílastæðum okkar og
                        því er engin hætta á tjóni af þeirra völdum.{' '}
                    </p>

                    <b>Þarf ég að bíða eftir bílnum þegar ég lendi?</b>
                    <p>
                        Nei, allajafna ekki. Við bíðum eftir þér og bíllinn er tilbúinn til brottfararmegin við Leifsstöð. Við
                        erum með upplýsingar um flugið þitt og fylgjumst með því hvenær flugvélin lendir. Ef þú hefur einhverjar
                        fyrirspurnir skaltu ekki hika við að hringja í okkur í síma 778-5999. Við erum mjög vinaleg.{' '}
                    </p>
                </Section>
            </div>
        );
    }
}

export default Qa;



// WEBPACK FOOTER //
// ./src/views/Qa.js